import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';

@Component({
    selector: 'base-list-filter',
    template: `
    <base-barprogress></base-barprogress>   
    <form [formGroup]="filtro" novalidate>
        <div class="ui-g-14 ui-md-12 ui-lg-12 form-group">
        <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Digite aqui sua consulta" formControlName="query"></form-text>
        <div class="ui-g-12  ui-md-12"></div>
        </div>
    </form>
    
    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabled">
        <button pButton type="button" [label]="btnLabel" class="ui-button-mandalay" icon="ui-icon-plus" [routerLink]="['./cadastrar']" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 20px;" *ngIf="btnEnabledConsultar && btnEnabled">
        <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="funcBusca($event)" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;" *ngIf="btnEnabledConsultar && !btnEnabled">
        <button pButton type="button" [label]="btnLabelConsultar" class="ui-button" icon="ui-icon-search" (click)="funcBusca($event)" ></button>
    </div>
    `})
export class BaseListFilterComponent {
    @Input() btnEnabled: boolean = true;
    @Input() btnEnabledConsultar: boolean = true;
    @Input() btnLabel: string = "Adicionar";
    btnLabelConsultar:string = "Consultar"
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;

    funcBusca(event){
        this.listagem.refresh(this.filtro.value)
    }
     
}




// WEBPACK FOOTER //
// ./src/app/base/base-list-filter.component.ts